import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const groupsAnimation = [
    trigger('groupsAnimation', [
        transition('void => *', [
            query(
                ':enter',
                [
                    style({
                        opacity: 0,
                        transform: 'translateY(-15%)',
                    }),
                    stagger(200, [
                        group([
                            animate(
                                '400ms 200ms ease',
                                style({
                                    opacity: 1,
                                }),
                            ),
                            animate(
                                '200ms 300ms ease',
                                style({
                                    transform: 'translateY(0)',
                                }),
                            ),
                        ]),
                    ]),
                ],
                { optional: true },
            ),
        ]),
    ]),
];
